<template>
    <div>
        <app-form
            v-bind:parentObject="{
            data: this.formData,
            pageTitle: this.pageTitle,
            errMsg: this.errMsg,
            }"
            v-on:input="formData = $event"
            v-on:save="saveHandler"
            v-on:error="errorHandler"
        />

        <div v-if="isErr">
            <app-error
            v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>

import WorkflowForm from "../../../components/settings/workflow/Form.vue";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": WorkflowForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            pageTitle: this.$t('workflowrole.createnewworkflowrole'),

            formData: {
                role: null,
                roledesc: null,
                systemrole: false,
                issupervisory: false,
                isdisable: false,
                remarks: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            errMsg: "",
            isErr: false
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        saveHandler() {
            
            const vm = this;

            // if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
            //     return false;
            // }

            // Convert boolean to integer. 1 = true, 0 = false
            if (this.formData.isdisable == false) {
                this.formData.isdisable = 0;
            } else {
                this.formData.isdisable = 1;
            }

            // Convert boolean to integer. 1 = true, 0 = false
            if (this.formData.systemrole == false) {
                this.formData.systemrole = 0;
            } else {
                this.formData.systemrole = 1;
            }

            // Convert boolean to integer. 1 = true, 0 = false
            if (this.formData.issupervisory == false) {
                this.formData.issupervisory = 0;
            } else {
                this.formData.issupervisory = 1;
            }

            console.log('data', vm.formData);

            this.$store.dispatch('post', {url: "/workflowrole/create", payload: this.formData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    this.$router.push({ name: "wfrolelist" });
                }
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });

        },
    },
};

</script>